import React from 'react';
import { Globe } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';

interface WebsiteStatusBannerProps {
  organization: any;
}

export const WebsiteStatusBanner: React.FC<WebsiteStatusBannerProps> = ({ organization }) => {
  // Don't show if Stage 2 (Website) hasn't been completed yet
  const stage2Completed = organization?.onboardingSetup?.stage2?.completed;

  if (!stage2Completed) return null;

  // Check if website was skipped
  const websiteData = organization?.onboardingData?.website;
  const isSkipped = websiteData?.skipped === true;

  if (isSkipped) return null;

  // Check if primary website was selected
  const isPrimaryWebsite = websiteData?.is_primary_website === 'yes';

  // Only show if user requested a website
  if (!isPrimaryWebsite) return null;

  // Hide banner if website has been marked as completed.
  // Accept legacy camelCase `websiteCompleted` from old Firestore onboarding.
  const completed = websiteData?.website_completed ?? websiteData?.websiteCompleted;
  if (completed === true) return null;

  return (
    <OnboardingStatusBanner icon={Globe} title="Website Design in Progress" variant="blue">
      <p className="text-xs">
        Our design team is working on your website. You'll receive updates at the email addresses
        you provided.
      </p>
    </OnboardingStatusBanner>
  );
};
